import { useState } from "react";
import { toast } from "sonner";
import { Gift, Share2, Copy, Check } from "lucide-react";

const SHARE_URL = "https://m8imhere.com/?utm_source=invite&utm_medium=referral";
const SHARE_TEXT =
  "I've been using m8 im here — it checks in on you every day and makes sure someone you trust knows if you ever go quiet. Everything you share is private, but if it senses you're in danger, it steps in. Thought of you 🌿";

export default function InviteCard() {
  const [copied, setCopied] = useState(false);

  const share = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: "m8 im here", text: SHARE_TEXT, url: SHARE_URL });
        return;
      } catch (e) {
        /* user cancelled or unsupported — fall through to copy */
      }
    }
    copy();
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(`${SHARE_TEXT}\n\n${SHARE_URL}`);
      setCopied(true);
      toast.success("Copied — paste it to someone who needs it 🌿");
      setTimeout(() => setCopied(false), 2500);
    } catch (e) {
      toast.error("Couldn't copy — you can select the text manually.");
    }
  };

  return (
    <section
      className="mt-6 rounded-3xl p-8 border border-[#2E9D96]/25 shadow-sm bg-gradient-to-br from-[#0E1417] to-[#123b38] text-white"
      data-testid="invite-card"
    >
      <div className="flex items-center gap-3">
        <div className="w-11 h-11 rounded-2xl bg-[#2E9D96]/20 text-[#3FC1B7] flex items-center justify-center shrink-0">
          <Gift size={20} />
        </div>
        <div>
          <h2 className="font-display text-2xl">Invite someone who needs it</h2>
          <p className="text-slate-300 text-sm mt-0.5">Know someone doing it tough? Pass Zaf on — it might be exactly what they need.</p>
        </div>
      </div>

      <p className="mt-5 text-[15px] leading-relaxed text-slate-200 bg-white/[0.04] border border-white/10 rounded-2xl p-4">
        {SHARE_TEXT}
      </p>

      <div className="mt-5 flex flex-wrap gap-3">
        <button
          onClick={share}
          data-testid="invite-share-btn"
          className="inline-flex items-center gap-2 bg-[#2E9D96] hover:bg-[#38B3AB] text-white font-semibold px-6 py-3 rounded-full transition-all hover:-translate-y-0.5"
        >
          <Share2 size={17} /> Share Zaf
        </button>
        <button
          onClick={copy}
          data-testid="invite-copy-btn"
          className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/15 text-white font-semibold px-6 py-3 rounded-full transition-colors"
        >
          {copied ? <Check size={17} /> : <Copy size={17} />} {copied ? "Copied" : "Copy link"}
        </button>
      </div>
    </section>
  );
}
